import React from 'react';

const BgExportButtons = ({ onDownloadPdf, onDownloadCsv }) => (
  <>
    <button type="button" className="btn-secondary" onClick={onDownloadPdf}>
      Download PDF
    </button>
    <button type="button" className="btn-secondary" onClick={onDownloadCsv}>
      Download CSV
    </button>
  </>
);

export default BgExportButtons;
